import { useState } from 'react';

export default function useModal(initialState) {
  const [visible, setVisible] = useState(initialState || false);
  const [modalData, setModalData] = useState({});

  const openModal = (newModalData) => {
    if (newModalData) setModalData(newModalData);
    setVisible(true);
  };

  const closeModal = () => setVisible(false);

  const toggleModal = () => setVisible(!visible);

  return {
    sharedStates: {
      visible,
      modalData,
    },
    commands: {
      openModal,
      closeModal,
      toggleModal,
    },
  };
}